import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {logo} from '../../assets/img/logo-white.png';

const errStyle = {
    color: 'red',
    fontSize: '14'
};

/**
 *
 */
class Login extends Component {
    state = {
        username: '',
        password: ''
    };

    componentDidMount(){
        this.props.authClear();
    }

    onKeyPress = (username, password, e) => {
        this.props.onLogin(username, password, this.props.browser);
    };

    render() {
        const {errorMessage} = this.props;
        const {username, password} = this.state;
        
        return (
            <div className="user-login-signup-wrap">
        <div className="ulsw-left-wrap">
            <div className="ulsw-left">
                <div className="uslw-top">
                    <div className="logo-wrap">
                        <a href="#"><img src={logo} /></a>    
                    </div>
                </div>
                <div className="uslw-middle">
                    <p className="left-content-wrap-head">99point9</p>   
                    <p className="left-content-wrap-description">Personalised learning. Guaranteed scores.</p>
                    <p className="left-content-wrap-details">Introducing: The world's first student-centric, personalised, and content-mastery-focused platform. </p>
                    <div className="button-wrap">
                        <a href="/">Get Started</a>
                    </div>
                </div>
                <div className="uslw-bottom">
         
                </div>
            </div>

        </div>
        <div className="ulsw-right-wrap">
            <div className="ulsw-right">

                <div className="uslw-box">
                    <div className="extra-top-right">
                        <div>
                            Don't have an account?
                        </div>
                        <div>
                            <Link to="/signup" className="btn btn-default">Create Account</Link>
                        </div>
                    </div>
                    <form className="login-form-wrap" onSubmit={e => {
                        e.preventDefault();
                        this.props.onLogin(username, password);
                    }
                    }>
                        <h1>Sign in to 99point9</h1>
                        <h2>Enter your details below.</h2>
                        
                        <div className="form-group">
                            <label>Email Address</label>
                            <input 
                                type="text" 
                                className="form-control"
                                required
                                value={this.state.username}
                                onChange={({target: {value}}) => this.setState({username: value})}
                            />
                        </div>
                        <div className="form-group">
                            <div className="flex flex-justify-content-space-between">
                                <label>Password</label>
                                <div className="text-right">
                                    <a href="forgot-password" className="fg-pass-text">Forgot Password?</a>
                                </div>
                            </div>
                            <input 
                                type="password" 
                                className="form-control" 
                                required
                                
                                value={this.state.password}
                                onChange={({target: {value}}) => this.setState({password: value})}
                            />
                        </div>
                        {
                                errorMessage &&
                                <span style={errStyle}>{errorMessage}</span>
                            }
                        <div className="form-group">
                        {this.props.loggingIn ?
                            <button type="submit" onClick={e => e.preventDefault()} className="btn btn-primary disabled">Signing In...</button>
                        :   
                            <button type="submit" className="btn btn-primary">Sign In</button>
                        }
                            
                        </div>
                    </form>
                    <div className="ifSafari text-center">
                        <i className="zmdi zmdi-alert"></i>
                        <h3 className="sm-bottom40">Uh oh! The browser you're currently using is not supported.</h3>
                        <p>Please use Google Chrome or Mozilla Firfox browser to access the portal.</p>
                    </div>


                </div>
            </div>
        </div>
    </div>    
        )

        return (
            <div className="app app-header-fixed loginSignupPage"
                 >
                <div className="container w-xxl w-auto-xs sm-bottom50">
                    <h3 className="font-100 sm-top100 sm-bottom50 text-center">Student Login</h3>
                    <div className="m-b-lg">
                        <form
                            name="form"
                            className="form-validation loginSignupForm"
                            onSubmit={(e) => {
                                e.preventDefault();
                                //this.onKeyPress(username, password, e);
                                this.props.onLogin(username, password);
                            }}
                        >
                            <div className="text-danger wrapper text-center">

                            </div>
                            <div className="list-group list-group-sm">
                                <div className="list-group-item">
                                    <input
                                        type="text"
                                        placeholder="Email"
                                        className="form-control no-border"
                                        required
                                        value={this.state.username}
                                        onChange={({target: {value}}) => this.setState({username: value})}
                                    />
                                </div>
                                <div className="list-group-item">
                                    <input
                                        type="password"
                                        placeholder="Password"
                                        className="form-control no-border"
                                        required
                                        value={this.state.password}
                                        onChange={({target: {value}}) => this.setState({password: value})}
                                    />
                                </div>
                            </div>
                            <button autoFocus type="submit" className="btn btn-lg btn-primary btn-block">Log in</button>
                            <div className="text-center m-t m-b"><Link to={'/forgot-password'}>Forgot password?</Link>
                            </div>
                            <div className="line line-dashed"></div>
                            <p className="text-center">
                                <small>Do not have an account?</small>
                            </p>
                            <Link to={'/signup'} className="btn btn-lg btn-default btn-block">Create an account</Link>
                            {
                                errorMessage &&
                                <span style={errStyle}>{errorMessage}</span>
                            }
                        </form>
                    </div>
                    <p className="text-center sm-bottom50"></p>
                </div>
            </div>
        )
    }
}

Login.propTypes = {
    errorMessage: PropTypes.string,
    onLogin: PropTypes.func.isRequired
};

export default Login;


// WEBPACK FOOTER //
// ./src/components/Auth/Login.js